import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCreativePerformanceSearchQueryApplied.meta';

export const useTrackCreativePerformanceSearchQueryApplied = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreativePerformanceSearchQueryApplied = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackCreativePerformanceSearchQueryApplied };
};
